<template>
  <div>
    <Menu
      mode="horizontal"
      :active-name="menu_name"
      @on-select="selectMenu"
      style="width: 100%"
    >
      <div
        v-for="(v, k) in menus"
        :key="k"
        style="display: inline-block"
        v-auth="v.auth"
      >
        <MenuItem
          :name="v.name"
          @click="v.onClick"
          v-show="v.show === true ? false : true"
        >
          <Badge
            :overflow-count="10000000"
            v-if="v.badge && v.badge.count"
            :count="v.badge.count"
            :offset="[18, -3]"
          >
            {{ v.label }}
          </Badge>
          <span v-if="!(v.badge && v.badge.count)">
            {{ v.label }}
          </span>
        </MenuItem>
      </div>
    </Menu>
    <div
      v-if="width && height"
      id="iframeBox"
      :style="{
        width: `${width}px`,
        height: `${height}px`,
        position: 'relative',
      }"
    >
      <div
        style="
          display: flex;
          justify-content: right;
          flex-direction: column;
          position: absolute;
          right: 20px;
          top: 15px;
        "
        @click="onC()"
      >
        <div style="color: red">复制对外展示链接</div>
        <!-- <Icon :size="30" type="md-expand"></Icon> -->
        <Icon :size="36" type="ios-copy" style="color: red" />
      </div>
      <iframe
        id="iframe"
        name="iframe"
        height="100%"
        width="100%"
        allow="fullscreen"
        :src="url"
      ></iframe>
    </div>
  </div>
</template>

<script>
// import Iframe from "@/views/components/base/Iframe";
import Iframe from "@/views/components/base/Iframe";
import Viewport from "@/utils/viewport";
export default {
  name: "dataView",
  data() {
    return {
      url: null,
      menu_name: "",
      width: null,
      height: null,
      //   viewport: null,
      menus: [
        {
          label: "大屏1",
          name: "largeScreen",
          auth: "/admin/dashboard/main",
        },
        {
          label: "大屏2",
          name: "largeScreen_view",
          auth: "/admin/dashboard/main",
        },
      ],
    };
  },
  created() {
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
  },
  mounted() {
    const me = this;

    me.Authorization = global.$utils.data.get("", "token");
    me.customerId = window.localStorage.getItem("customerId");
    me.customerName =
      window.localStorage.getItem("customerName") + "数字运维服务平台";
    // me.url = 'https://dev.gemcoder.com:7779/front/development/view/95caf460e82f453e873ad63744838d68$$0$$c234faa72515478aaaa209382af25b53?token='+me.Authorization+"&customerId="+me.customerId+"&customerName="+me.customerName+"&uniqueId="+uuid;
    me.url =
      "https://dpkshTwo.hi-eweibao.com/#/?" +
      // "http://localhost:9528/#/?" +
      "customerId=" +
      me.customerId +
      "&customerName=" +
      me.customerName;

    // me.url = 'https://uihkmed.hi-eweibao.com'

    this.viewport = new Viewport(this);
  },
  methods: {
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    // buildShortUUID() {
    //   let unique = 0;
    //   const time = Date.now();
    //   const random = Math.floor(Math.random() * 1000000000);
    //   // eslint-disable-next-line no-undef
    //   unique++;
    //   return random + unique + String(time);
    // },
    fallbackCopy(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
        alert("✅ 已复制当前链接");
      } catch (err) {
        alert("❌ 复制失败，请手动复制：\n" + text);
      }

      document.body.removeChild(textArea);
    },
    onC() {
      if (navigator.clipboard && window.isSecureContext) {
        // 支持 Clipboard API 且是 HTTPS 环境
        navigator.clipboard
          .writeText(this.url)
          .then(() => alert("链接已复制"))
          .catch((err) => console.error(err));
      } else {
        // 降级方案（兼容 HTTP 或旧浏览器）
        this.fallbackCopy(this.url);
      }

      // let case1 = document.getElementById("iframe");
      // if (this.fullscreen) {
      //   if (document.exitFullscreen) {
      //     document.exitFullscreen();
      //   } else if (document.webkitCancelFullScreen) {
      //     document.webkitCancelFullScreen();
      //   } else if (document.mozCancelFullScreen) {
      //     document.mozCancelFullScreen();
      //   } else if (document.msExitFullscreen) {
      //     document.msExitFullscreen();
      //   }
      // } else {
      //   if (case1.requestFullscreen) {
      //     case1.requestFullscreen();
      //   } else if (case1.webkitRequestFullScreen) {
      //     case1.webkitRequestFullScreen();
      //   } else if (case1.mozRequestFullScreen) {
      //     case1.mozRequestFullScreen();
      //   } else if (case1.msRequestFullscreen) {
      //     // IE11
      //     case1.msRequestFullscreen();
      //   }
      // }
    },
  },
  destroyed() {
    this.viewport.onDestroyed();
  },
};
</script>

<style>
</style>